module.exports = __webpack_public_path__ + "d5.no2.222d9b14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/d5.no2.jpg
// module id = MgQU
// module chunks = 0